import React from "react";
import * as XLSX from "xlsx";

const data = [
  [
    "No. (#)",
    "Model No.",
    "Status",
    "Pallet No.",
    "Carton No.",
    "Serial No.",
    "ETH MAC",
    "Wi-Fi MAC",
    "Bluetooth MAC",
    "Manufacture date",
    "Factory/line",
    "Chipset ID",
    "Storage (flash)",
    "Memory (RAM)",
    "RCU S/N",
    "HW Ver",
    "FW Ver",
  ],
  [
    1,
    "FPT Play Box S",
    "init",
    "Pallet No.1",
    "cat_001",
    "serial_001",
    "b8:27:eb:ff:00:00",
    "dca6321066d8",
    "b8:27:eb:00:00:00",
    "Exp. 3-2025",
    1,
    "AMD Ryzen 7 7735HS",
    "Storage 1",
    "4gb",
    "Rcu Simon",
    "",
    "",
  ],
  [
    2,
    "Đèn LED Downlight Thông Minh",
    "active",
    "Pallet No.2",
    "cat_002",
    "serial_002",
    "b8:27:eb:ff:00:00",
    "dca6321066d8",
    "b8:27:eb:00:00:00",
    "Exp. 3-2025",
    2,
    "Intel Core i5-12600H",
    "Storage 2",
    "8gb",
    "Rcu Simon",
    "",
    "",
  ],

  [
    3,
    "USB ZigBee",
    "blocked",
    "Pallet No.5",
    "cat_005",
    "serial_005",
    "b8:27:eb:ff:00:00",
    "dca6321066d8",
    "b8:27:eb:00:00:00",
    "Exp. 3-2025",
    5,
    "Intel Core i7-11600H",
    "Storage 5",
    "64gb",
    "Rcu Simon",
    "",
    "",
  ],
];

const XLSXDownload = () => {
  const handleDownload = () => {
    // create a new workbook
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);

    // add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // generate xlsx file
    XLSX.writeFile(wb, "white_list_device.xlsx");
  };

  return (
    <button
      type="button"
      onClick={handleDownload}
      className="btn btn-primary"
      style={{ marginTop: 5 + "px" }}
    >
      Download file sample
    </button>
  );
};

export default XLSXDownload;
